import {styled} from '@mui/material'
import {
    DatePicker as RawDatePicker,
    LocalizationProvider,
} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Controller} from 'react-hook-form'
import {FormErrorText} from '.'
import Input from '../Input'
import moment from 'moment'

const FormDatePicker = ({
    name,
    control,
    rules,
    required,
    label,
    errors,
    format = 'YYYY-MM-DD',
    pickerDateFormat,
    ...p
}) => {
    return (
        <Container>
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) => (
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            onChange={(value) => onChange(value.format(format))}
                            value={value ? moment(value) : null}
                            label={label}
                            slots={{textField: Input}}
                            format={pickerDateFormat}
                            slotProps={{
                                popper: {
                                    style: {
                                        direction: 'rtl',
                                    },
                                },
                            }}
                            {...p}
                        />
                    </LocalizationProvider>
                )}
            />
            {errors?.[name] && (
                <FormErrorText>{errors[name].message}</FormErrorText>
            )}
        </Container>
    )
}

export default FormDatePicker

const Container = styled('div')`
    width: 100%;
`

const DatePicker = styled(RawDatePicker)`
    & .MuiPickersCalendarHeader-labelContainer {
        background: red;
        margin: 0;
    }
`
